import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(Meta)

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      name: 'root',
      path: '/',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Home'
      },
      children: [
        {
          name: 'rootHome',
          path: '',
          component: () => import('./pages/home.vue'),
          meta: {
            title: 'Home'
          }
        }
      ]
    },
    {
      name: 'home',
      path: '/home',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Home'
      },
      children: [
        {
          name: 'homeHome',
          path: '',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Home'
          }
        },
        {
          name: 'gettingStarted',
          path: 'getting-started',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Getting started'
          },
          children: [
            {
              name: 'basics',
              path: 'basics',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Basics'
              },
              children: [
                {
                  name: 'aboutConicleDesignSystem',
                  path: 'about-conicle-design-system',
                  component: () => import('./pages/home/getting-started/basics/about-conicle-design-system.vue'),
                  meta: {
                    title: 'About Conicle design system'
                  }
                },
                {
                  name: 'changelog',
                  path: 'changelog',
                  component: () => import('./pages/home/getting-started/basics/changelog.vue'),
                  meta: {
                    title: 'Changelog'
                  }
                },
                {
                  name: 'contactUs',
                  path: 'contact-us',
                  component: () => import('./pages/home/getting-started/basics/contact-us.vue'),
                  meta: {
                    title: 'Contact us'
                  }
                }
              ]
            },
            {
              name: 'uiLibrary',
              path: 'ui-library',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Components library'
              },
              children: [
                {
                  name: 'aboutTheLib',
                  path: 'about-the-lib',
                  component: () => import('./pages/home/getting-started/ui-library/about-the-lib.vue'),
                  meta: {
                    title: 'About the lib'
                  }
                },
                {
                  name: 'installingAndUsingTheLib',
                  path: 'installing-and-using-the-lib',
                  component: () => import('./pages/home/getting-started/ui-library/installing-and-using-the-lib.vue'),
                  meta: {
                    title: 'Installing and using the lib'
                  }
                },
                {
                  name: 'versionControl',
                  path: 'version-control',
                  component: () => import('./pages/home/getting-started/ui-library/version-control.vue'),
                  meta: {
                    title: 'Version control'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'account',
      path: '/account',
      component: () => import('./layouts/default.vue'),
      meta: {
        title: 'Account'
      },
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('./pages/account/login.vue'),
          meta: {
            title: 'Login'
          }
        }
      ]
    },
    {
      name: 'brand',
      path: '/brand',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Brand'
      },
      children: [
        {
          name: 'brandHome',
          path: '',
          component: () => import('./pages/brand.vue'),
          meta: {
            title: 'Brand'
          }
        },
        {
          name: 'conicleCorporate',
          path: 'conicle-corporate',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Conicle corporate'
          },
          children: [
            {
              name: 'whoWeAreConicle',
              path: 'who-we-are',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Who we are'
              },
              children: [
                {
                  name: 'attributeAndPersonalityConicle',
                  path: 'attribute-and-personality',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/attribute-and-personality.vue'),
                  meta: {
                    title: 'Attribute and personality'
                  }
                },
                {
                  name: 'brandArchitectureConicle',
                  path: 'brand-architecture',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/brand-architecture.vue'),
                  meta: {
                    title: 'Brand architecture'
                  }
                },
                {
                  name: 'brandDNAConicle',
                  path: 'brand-dna',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/brand-dna.vue'),
                  meta: {
                    title: 'Brand DNA'
                  }
                },
                {
                  name: 'brandValuesAndPositioningConicle',
                  path: 'brand-values-and-positioning',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/brand-values-and-positioning.vue'),
                  meta: {
                    title: 'Brand values and positioning'
                  }
                },
                {
                  name: 'designPrinciplesConicle',
                  path: 'design-principles',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/design-principles.vue'),
                  meta: {
                    title: 'Design principles'
                  }
                },
                {
                  name: 'visionMissionAndPurposeConicle',
                  path: 'vision-mission-and-purpose',
                  component: () => import('./pages/brand/conicle-corporate/who-we-are/vision-mission-and-purpose.vue'),
                  meta: {
                    title: 'Vision, mission, and purpose'
                  }
                }
              ]
            },
            {
              name: 'verbalExpressionConicle',
              path: 'verbal-expression',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Verbal expression'
              },
              children: [
                {
                  name: 'taglineAndKeyMessageConicle',
                  path: 'tagline-and-key-message',
                  component: () => import('./pages/brand/conicle-corporate/verbal-expression/tagline-and-key-message.vue'),
                  meta: {
                    title: 'Tagline and key message'
                  }
                },
                {
                  name: 'voiceAndToneConicle',
                  path: 'voice-and-tone',
                  component: () => import('./pages/brand/conicle-corporate/verbal-expression/voice-and-tone.vue'),
                  meta: {
                    title: 'Voice and tone'
                  }
                }
              ]
            },
            {
              name: 'visualCommunicationConicle',
              path: 'visual-communication',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Visual communication'
              },
              children: [
                {
                  name: 'colorsConicle',
                  path: 'colors',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                {
                  name: 'iconographyConicle',
                  path: 'iconography',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/iconography.vue'),
                  meta: {
                    title: 'Iconography'
                  }
                },
                {
                  name: 'illustrationConicle',
                  path: 'illustration',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/illustration.vue'),
                  meta: {
                    title: 'Illustration'
                  }
                },
                {
                  name: 'imageryConicle',
                  path: 'imagery',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/imagery.vue'),
                  meta: {
                    title: 'Imagery'
                  }
                },
                {
                  name: 'infographicConicle',
                  path: 'infographic',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/infographic.vue'),
                  meta: {
                    title: 'Infographic'
                  }
                },
                {
                  name: 'keyVisualsConicle',
                  path: 'key-visuals',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/key-visuals.vue'),
                  meta: {
                    title: 'Key visuals'
                  }
                },
                {
                  name: 'logosConicle',
                  path: 'logos',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/logos.vue'),
                  meta: {
                    title: 'Logos'
                  }
                },
                {
                  name: 'mascotConicle',
                  path: 'mascot',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/mascot.vue'),
                  meta: {
                    title: 'Mascot'
                  }
                },
                {
                  name: 'motionConicle',
                  path: 'motion',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/motion.vue'),
                  meta: {
                    title: 'Motion'
                  }
                },
                {
                  name: 'typographyConicle',
                  path: 'typography',
                  component: () => import('./pages/brand/conicle-corporate/visual-communication/typography.vue'),
                  meta: {
                    title: 'Typography'
                  }
                }
              ]
            },
            {
              name: 'supportConicle',
              path: 'support',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Support'
              },
              children: [
                {
                  name: 'faqsConicle',
                  path: 'faqs',
                  component: () => import('./pages/brand/conicle-corporate/support/faqs.vue'),
                  meta: {
                    title: 'FAQs'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'conicleSpace',
          path: 'conicle-space',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Conicle Space'
          },
          children: [
            {
              name: 'verbalExpressionSpace',
              path: 'verbal-expression',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Verbal expression'
              },
              children: [
                {
                  name: 'voiceAndToneSpace',
                  path: 'voice-and-tone',
                  component: () => import('./pages/brand/conicle-space/verbal-expression/voice-and-tone.vue'),
                  meta: {
                    title: 'Voice and tone'
                  }
                }
              ]
            },
            {
              name: 'visualCommunicationSpace',
              path: 'visual-communication',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Visual communication'
              },
              children: [
                {
                  name: 'colorsSpace',
                  path: 'colors',
                  component: () => import('./pages/brand/conicle-space/visual-communication/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                {
                  name: 'keyVisualsSpace',
                  path: 'key-visuals',
                  component: () => import('./pages/brand/conicle-space/visual-communication/key-visuals.vue'),
                  meta: {
                    title: 'Key visuals'
                  }
                },
                {
                  name: 'packageLogos',
                  path: 'package-logos',
                  component: () => import('./pages/brand/conicle-space/visual-communication/package-logos.vue'),
                  meta: {
                    title: 'Package logos'
                  }
                },
                {
                  name: 'productLineLogos',
                  path: 'product-line-logos',
                  component: () => import('./pages/brand/conicle-space/visual-communication/product-line-logos.vue'),
                  meta: {
                    title: 'Product line logos'
                  }
                }
              ]
            },
            {
              name: 'supportSpace',
              path: 'support',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Support'
              },
              children: [
                {
                  name: 'faqsSpace',
                  path: 'faqs',
                  component: () => import('./pages/brand/conicle-space/support/faqs.vue'),
                  meta: {
                    title: 'FAQs'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'coniverse',
          path: 'coniverse',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Coniverse'
          },
          children: [
            {
              name: 'verbalExpressionConiverse',
              path: 'verbal-expression',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Verbal expression'
              },
              children: [
                {
                  name: 'voiceAndToneConiverse',
                  path: 'voice-and-tone',
                  component: () => import('./pages/brand/coniverse/verbal-expression/voice-and-tone.vue'),
                  meta: {
                    title: 'Voice and tone'
                  }
                }
              ]
            },
            {
              name: 'visualCommunicationConiverse',
              path: 'visual-communication',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Visual communication'
              },
              children: [
                {
                  name: 'colorsConiverse',
                  path: 'colors',
                  component: () => import('./pages/brand/coniverse/visual-communication/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                {
                  name: 'keyVisualsConiverse',
                  path: 'key-visuals',
                  component: () => import('./pages/brand/coniverse/visual-communication/key-visuals.vue'),
                  meta: {
                    title: 'Key visuals'
                  }
                },
                {
                  name: 'logosConiverse',
                  path: 'logos',
                  component: () => import('./pages/brand/coniverse/visual-communication/logos.vue'),
                  meta: {
                    title: 'Logos'
                  }
                }
              ]
            },
            {
              name: 'supportConiverse',
              path: 'support',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Support'
              },
              children: [
                {
                  name: 'faqsConiverse',
                  path: 'faqs',
                  component: () => import('./pages/brand/coniverse/support/faqs.vue'),
                  meta: {
                    title: 'FAQs'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'solutions',
          path: 'solutions',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Solutions'
          },
          children: [
            {
              name: 'verbalExpressionSolutions',
              path: 'verbal-expression',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Verbal expression'
              },
              children: [
                {
                  name: 'voiceAndToneSolutions',
                  path: 'voice-and-tone',
                  component: () => import('./pages/brand/solutions/verbal-expression/voice-and-tone.vue'),
                  meta: {
                    title: 'Voice and tone'
                  }
                }
              ]
            },
            {
              name: 'visualCommunicationSolutions',
              path: 'visual-communication',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Visual communication'
              },
              children: [
                {
                  name: 'colorsSolutions',
                  path: 'colors',
                  component: () => import('./pages/brand/solutions/visual-communication/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                {
                  name: 'keyVisualsSolutions',
                  path: 'key-visuals',
                  component: () => import('./pages/brand/solutions/visual-communication/key-visuals.vue'),
                  meta: {
                    title: 'Key visuals'
                  }
                },
                {
                  name: 'logosSolutions',
                  path: 'logos',
                  component: () => import('./pages/brand/solutions/visual-communication/logos.vue'),
                  meta: {
                    title: 'Logos'
                  }
                }
              ]
            },
            {
              name: 'supportSolutions',
              path: 'support',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Support'
              },
              children: [
                {
                  name: 'faqsSolutions',
                  path: 'faqs',
                  component: () => import('./pages/brand/solutions/support/faqs.vue'),
                  meta: {
                    title: 'FAQs'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'weAreConicle',
          path: 'we-are-conicle',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'We are Conicle'
          },
          children: [
            {
              name: 'verbalExpressionWeAreConicle',
              path: 'verbal-expression',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Verbal expression'
              },
              children: [
                {
                  name: 'voiceAndToneWeAreConicle',
                  path: 'voice-and-tone',
                  component: () => import('./pages/brand/we-are-conicle/verbal-expression/voice-and-tone.vue'),
                  meta: {
                    title: 'Voice and tone'
                  }
                }
              ]
            },
            {
              name: 'visualCommunicationWeAreConicle',
              path: 'visual-communication',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Visual communication'
              },
              children: [
                {
                  name: 'colorsWeAreConicle',
                  path: 'colors',
                  component: () => import('./pages/brand/we-are-conicle/visual-communication/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                {
                  name: 'keyVisualsWeAreConicle',
                  path: 'key-visuals',
                  component: () => import('./pages/brand/we-are-conicle/visual-communication/key-visuals.vue'),
                  meta: {
                    title: 'Key visuals'
                  }
                },
                {
                  name: 'logosWeAreConicle',
                  path: 'logos',
                  component: () => import('./pages/brand/we-are-conicle/visual-communication/logos.vue'),
                  meta: {
                    title: 'Logos'
                  }
                }
              ]
            },
            {
              name: 'supportWeAreConicle',
              path: 'support',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Support'
              },
              children: [
                {
                  name: 'faqsWeAreConicle',
                  path: 'faqs',
                  component: () => import('./pages/brand/we-are-conicle/support/faqs.vue'),
                  meta: {
                    title: 'FAQs'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'foundations',
      path: '/foundations',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Foundations'
      },
      children: [
        {
          name: 'foundationsHome',
          path: '',
          component: () => import('./pages/foundations.vue'),
          meta: {
            title: 'Foundations'
          }
        },
        {
          name: 'conicleSpaceAndConiverse',
          path: 'conicle-space-and-coniverse',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Foundations'
          },
          children: [
            {
              name: 'designElements',
              path: 'design-elements',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Design elements'
              },
              children: [
                {
                  name: 'borderRadius',
                  path: 'border-radius',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/border-radius.vue'),
                  meta: {
                    title: 'Border radius'
                  }
                },
                {
                  name: 'breakpoints',
                  path: 'breakpoints',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/breakpoints.vue'),
                  meta: {
                    title: 'Breakpoints'
                  }
                },
                {
                  name: 'fonts',
                  path: 'fonts',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/fonts.vue'),
                  meta: {
                    title: 'Fonts'
                  }
                },
                {
                  name: 'motions',
                  path: 'motions',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/motions.vue'),
                  meta: {
                    title: 'Motions'
                  }
                },
                {
                  name: 'shadows',
                  path: 'shadows',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/shadows.vue'),
                  meta: {
                    title: 'Shadows'
                  }
                },
                {
                  name: 'spacings',
                  path: 'spacings',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/spacings.vue'),
                  meta: {
                    title: 'Spacings'
                  }
                },
                {
                  name: 'colors',
                  path: 'colors',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/colors.vue'),
                  meta: {
                    title: 'Colors'
                  }
                },
                // {
                //   name: 'cncIcon',
                //   path: 'cnc-icon',
                //   component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/cnc-icon.vue'),
                //   meta: {
                //     title: 'CNC icon'
                //   }
                // },
                {
                  name: 'deprecatedIcons',
                  path: 'deprecated-icons',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/deprecated-icons.vue'),
                  meta: {
                    title: 'Deprecated icons'
                  }
                },
                {
                  name: 'icons',
                  path: 'icons',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/icons.vue'),
                  meta: {
                    title: 'Icons'
                  },
                  children: [
                    {
                      name: 'fontIcon',
                      path: '',
                      component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/icons/font-icon.vue'),
                      meta: {
                        title: 'Icons'
                      }
                    },
                    {
                      name: 'svgIcon',
                      path: 'svg-icons',
                      component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/icons/svg-icon.vue'),
                      meta: {
                        title: 'Icons'
                      }
                    },
                    {
                      name: 'contentType',
                      path: 'content-type',
                      component: () => import('./pages/foundations/conicle-space-and-coniverse/design-elements/icons/content-type.vue'),
                      meta: {
                        title: 'Icons'
                      }
                    }
                  ]
                }
              ]
            },
            {
              name: 'content',
              path: 'content',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Content'
              },
              children: [
                {
                  name: 'dateAndTimeFormats',
                  path: 'date-and-time-formats',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/content/date-and-time-formats.vue'),
                  meta: {
                    title: 'Date and time formats'
                  }
                },
                {
                  name: 'writingStandards',
                  path: 'writing-standards',
                  component: () => import('./pages/foundations/conicle-space-and-coniverse/content/writing-standards.vue'),
                  meta: {
                    title: 'Writing standards'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'components',
      path: '/components',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Components'
      },
      children: [
        {
          name: 'componentsHome',
          path: '',
          component: () => import('./pages/components.vue'),
          meta: {
            title: 'Components'
          }
        },
        {
          name: 'conicleSpaceAndConiverse',
          path: 'conicle-space-and-coniverse',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Components'
          },
          children: [
            {
              name: 'components',
              path: 'components',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Components'
              },
              children: [
                {
                  name: 'loading',
                  path: 'loading',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/loading.vue'),
                  meta: {
                    title: 'Loading'
                  }
                },
                {
                  name: 'badgeDot',
                  path: 'badge-dot',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/badge-dot.vue'),
                  meta: {
                    title: 'Badge dot'
                  }
                },
                {
                  name: 'button',
                  path: 'button',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/button.vue'),
                  meta: {
                    title: 'Button'
                  }
                },
                {
                  name: 'iconButton',
                  path: 'icon-button',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/icon-button.vue'),
                  meta: {
                    title: 'Icon button'
                  }
                },
                {
                  name: 'badgeLabel',
                  path: 'badge-label',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/badge-label.vue'),
                  meta: {
                    title: 'Badge label'
                  }
                },
                {
                  name: 'badgeNumber',
                  path: 'badge-number',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/badge-number.vue'),
                  meta: {
                    title: 'Badge number'
                  }
                },
                {
                  name: 'switch',
                  path: 'switch',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/switch.vue'),
                  meta: {
                    title: 'Switch'
                  }
                },
                {
                  name: 'pagination',
                  path: 'pagination',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/pagination.vue'),
                  meta: {
                    title: 'Pagination'
                  }
                },
                {
                  name: 'btnBackToTop',
                  path: 'button-back-to-top',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/button-back-to-top.vue'),
                  meta: {
                    title: 'Btn back to top'
                  }
                },
                {
                  name: 'checkbox',
                  path: 'checkbox',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/checkbox.vue'),
                  meta: {
                    title: 'Checkbox'
                  }
                },
                {
                  name: 'checkboxGroup',
                  path: 'checkbox-group',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/checkbox-group.vue'),
                  meta: {
                    title: 'Checkbox group'
                  }
                },
                {
                  name: 'radioButton',
                  path: 'radio-button',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/radio-button.vue'),
                  meta: {
                    title: 'Radio button'
                  }
                },
                {
                  name: 'radioButtonGroup',
                  path: 'radio-button-group',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/radio-button-group.vue'),
                  meta: {
                    title: 'Radio button group'
                  }
                },
                {
                  name: 'tabMenu',
                  path: 'tab-menu',
                  component: () => import('./pages/components/conicle-space-and-coniverse/components/tab-menu/index.vue'),
                  meta: {
                    title: 'Tab menu'
                  },
                  children: [
                    {
                      name: 'tab1',
                      path: 'tab1',
                      component: () => import('./pages/components/conicle-space-and-coniverse/components/tab-menu/tab1.vue'),
                      meta: {
                        title: 'Tab 1'
                      }
                    },
                    {
                      name: 'tab2',
                      path: 'tab2',
                      component: () => import('./pages/components/conicle-space-and-coniverse/components/tab-menu/tab2.vue'),
                      meta: {
                        title: 'Tab 2'
                      }
                    },
                    {
                      name: 'tab3',
                      path: 'tab3',
                      component: () => import('./pages/components/conicle-space-and-coniverse/components/tab-menu/tab3.vue'),
                      meta: {
                        title: 'Tab 3'
                      }
                    },
                    {
                      name: 'tab4',
                      path: 'tab4',
                      component: () => import('./pages/components/conicle-space-and-coniverse/components/tab-menu/tab4.vue'),
                      meta: {
                        title: 'Tab 4'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'resources',
      path: '/resources',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Resources'
      },
      children: [
        {
          name: 'resourcesHome',
          path: '',
          component: () => import('./pages/resources.vue'),
          meta: {
            title: 'Resources'
          }
        },
        {
          name: 'logos',
          path: 'logos',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Logos'
          },
          children: [
            {
              name: 'categories',
              path: 'categories',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Categories'
              },
              children: [
                {
                  name: 'conicleCorporate',
                  path: 'conicle-corporate',
                  component: () => import('./pages/resources/logos/categories/conicle-corporate.vue'),
                  meta: {
                    title: 'Conicle corporate'
                  }
                },
                {
                  name: 'coniverseContents',
                  path: 'coniverse-contents',
                  component: () => import('./pages/resources/logos/categories/coniverse-contents.vue'),
                  meta: {
                    title: 'Coniverse contents'
                  }
                },
                {
                  name: 'coniverse',
                  path: 'coniverse',
                  component: () => import('./pages/resources/logos/categories/coniverse.vue'),
                  meta: {
                    title: 'Coniverse'
                  }
                },
                {
                  name: 'customersByIndustry',
                  path: 'customers-by-industry',
                  component: () => import('./pages/resources/logos/categories/customers-by-industry.vue'),
                  meta: {
                    title: 'Customers by industry'
                  }
                },
                {
                  name: 'departmentsAndTeams',
                  path: 'departments-and-teams',
                  component: () => import('./pages/resources/logos/categories/departments-and-teams.vue'),
                  meta: {
                    title: 'Departments and teams'
                  }
                },
                {
                  name: 'partnersContentProvider',
                  path: 'partners-content-providers',
                  component: () => import('./pages/resources/logos/categories/partners-content-providers.vue'),
                  meta: {
                    title: 'Partners content provider'
                  }
                },
                {
                  name: 'solutions',
                  path: 'solutions',
                  component: () => import('./pages/resources/logos/categories/solutions.vue'),
                  meta: {
                    title: 'Solutions'
                  }
                },
                {
                  name: 'space',
                  path: 'space',
                  component: () => import('./pages/resources/logos/categories/conicle-space.vue'),
                  meta: {
                    title: 'Space'
                  }
                },
                {
                  name: 'weAreConicle',
                  path: 'we-are-conicle',
                  component: () => import('./pages/resources/logos/categories/we-are-conicle.vue'),
                  meta: {
                    title: 'We are Conicle'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'icons',
          path: 'icons',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Icons'
          },
          children: [
            {
              name: 'productsAndFeatures',
              path: 'products-and-features',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Products and features'
              },
              children: [
                {
                  name: 'coniverse',
                  path: 'coniverse',
                  component: () => import('./pages/resources/icons/products-and-features/coniverse.vue'),
                  meta: {
                    title: 'Coniverse'
                  }
                },
                {
                  name: 'conicleSpace',
                  path: 'conicle-space',
                  component: () => import('./pages/resources/icons/products-and-features/conicle-space.vue'),
                  meta: {
                    title: 'Conicle Space'
                  }
                }
              ]
            },
            {
              name: 'others',
              path: 'others',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Others'
              },
              children: [
                {
                  name: 'corporateAndServices',
                  path: 'corporate-and-services',
                  component: () => import('./pages/resources/icons/others/corporate-and-services.vue'),
                  meta: {
                    title: 'Corporate and services'
                  }
                },
                {
                  name: 'general',
                  path: 'general',
                  component: () => import('./pages/resources/icons/others/general.vue'),
                  meta: {
                    title: 'General'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'otherAssets',
          path: 'other-resources',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Other assets'
          },
          children: [
            {
              name: 'designAssets',
              path: 'design-assets',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Design assets'
              },
              children: [
                {
                  name: 'fonts',
                  path: 'fonts',
                  component: () => import('./pages/resources/other-resources/design-assets/fonts.vue'),
                  meta: {
                    title: 'Fonts'
                  }
                },
                {
                  name: 'illustrations',
                  path: 'illustrations',
                  component: () => import('./pages/resources/other-resources/design-assets/illustrations.vue'),
                  meta: {
                    title: 'Illustrations'
                  }
                },
                {
                  name: 'images',
                  path: 'images',
                  component: () => import('./pages/resources/other-resources/design-assets/images.vue'),
                  meta: {
                    title: 'Images'
                  }
                },
                {
                  name: 'mascots',
                  path: 'mascots',
                  component: () => import('./pages/resources/other-resources/design-assets/mascots.vue'),
                  meta: {
                    title: 'Mascots'
                  }
                }
              ]
            },
            {
              name: 'templates',
              path: 'templates',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Templates'
              },
              children: [
                {
                  name: 'marketing',
                  path: 'marketing',
                  component: () => import('./pages/resources/other-resources/templates/marketing.vue'),
                  meta: {
                    title: 'Marketing'
                  }
                },
                {
                  name: 'presentation',
                  path: 'presentation',
                  component: () => import('./pages/resources/other-resources/templates/presentation.vue'),
                  meta: {
                    title: 'Presentation'
                  }
                },
                {
                  name: 'productionArtworks',
                  path: 'production-artworks',
                  component: () => import('./pages/resources/other-resources/templates/production-artworks.vue'),
                  meta: {
                    title: 'Production artworks'
                  }
                }
              ]
            },
            {
              name: 'documents',
              path: 'documents',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Documents'
              },
              children: [
                {
                  name: 'brandGuidelines',
                  path: 'brand-guidelines',
                  component: () => import('./pages/resources/other-resources/documents/brand-guidelines.vue'),
                  meta: {
                    title: 'Brand guidelines'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'knowledges',
      path: '/knowledges',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'Knowledges'
      },
      children: [
        {
          name: 'knowledgesHome',
          path: '',
          component: () => import('./pages/knowledges.vue'),
          meta: {
            title: 'Knowledges'
          }
        },
        {
          name: 'conicleSpace',
          path: 'conicle-space',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Conicle Space'
          },
          children: [
            {
              name: 'standard',
              path: 'standard',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Standard'
              },
              children: [
                {
                  name: 'permission',
                  path: 'permission',
                  component: () => import('./pages/knowledges/conicle-space/standard/permission.vue'),
                  meta: {
                    title: 'Permission'
                  }
                }
              ]
            },
            {
              name: 'lxp',
              path: 'lxp',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'LXP'
              },
              children: [
                {
                  name: 'lxp101',
                  path: 'lxp-101',
                  component: () => import('./pages/knowledges/conicle-space/lxp/lxp-101.vue'),
                  meta: {
                    title: 'LXP 101'
                  }
                }
              ]
            },
            {
              name: 'lms',
              path: 'lms',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'LMS'
              },
              children: [
                {
                  name: 'classAndClassProgram',
                  path: 'class-and-class-program',
                  component: () => import('./pages/knowledges/conicle-space/lms/class-and-class-program.vue'),
                  meta: {
                    title: 'Class and class program'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'design',
          path: 'design',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Design'
          },
          children: [
            {
              name: 'design101',
              path: 'design-101',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Design 101'
              },
              children: [
                {
                  name: 'uxuiGlossary',
                  path: 'uxui-glossary',
                  component: () => import('./pages/knowledges/design/design-101/uxui-glossary.vue'),
                  meta: {
                    title: 'UXUI glossary'
                  }
                }
              ]
            },
            {
              name: 'designReferences',
              path: 'design-references',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'Design references'
              },
              children: [
                {
                  name: 'gamificationUI',
                  path: 'gamification-ui',
                  component: () => import('./pages/knowledges/design/design-references/gamification-ui.vue'),
                  meta: {
                    title: 'Gamification Components'
                  }
                }
              ]
            }
          ]
        },
        {
          name: 'business',
          path: 'business',
          component: () => import('./pages/router.vue'),
          meta: {
            title: 'Business'
          },
          children: [
            {
              name: 'hrd101',
              path: 'hrd-101',
              component: () => import('./pages/router.vue'),
              meta: {
                title: 'HRD 101'
              },
              children: [
                {
                  name: 'hrdGlossary',
                  path: 'hrd-glossary',
                  component: () => import('./pages/knowledges/business/hrd-101/hrd-glossary.vue'),
                  meta: {
                    title: 'HRD glossary'
                  }
                },
                {
                  name: 'productCategories',
                  path: 'product-categories',
                  component: () => import('./pages/knowledges/business/hrd-101/product-categories.vue'),
                  meta: {
                    title: 'Product categories'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/token',
      component: () => import('./layouts/storybook.vue'),
      meta: {
        title: 'token'
      },
      children: [
        {
          name: 'font',
          path: 'font',
          component: () => import('./pages/token/font')
        },
        {
          name: 'shadow',
          path: 'shadow',
          component: () => import('./pages/token/shadow')
        },
        {
          name: 'radius',
          path: 'radius',
          component: () => import('./pages/token/radius')
        },
        {
          name: 'color',
          path: 'color',
          component: () => import('./pages/token/color')
        }
      ]
    }

  ]
})

const publicRoutes = ['/account/login']

Router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} - Conicle Design System`

  const isAuthenticated = sessionStorage.getItem('authUser')
  if (publicRoutes.includes(to.path)) {
    return next()
  }
  if (!isAuthenticated) {
    return next('/account/login')
  }
  next()
})

export default Router
